class ScrollingFeaturesBar {
    constructor(options = {}) {
        this.options = options, this.init()
    }
    init() {
        document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => this.setup()) : this.setup(), window.addEventListener("resize", () => this.adjustFeaturesTrack()), document.fonts && document.fonts.ready.then(() => {
            this.setup()
        })
    }
    setup() {
        document.querySelectorAll('[class*="section-"]').forEach(section => {
            section.querySelector(".features-track") && this.initSection(section)
        })
    }
    initSection(section) {
        const trackContainer = section.querySelector(".features-track-container"),
            track = section.querySelector(".features-track"),
            featureItems = track.querySelector(".feature-items");
        !trackContainer || !track || !featureItems || (this.configureScrollingAnimation(section, track, featureItems), this.adjustFeaturesTrack(section, trackContainer, track, featureItems))
    }
    configureScrollingAnimation(section, track, featureItems) {
        const sectionIdMatch = section.className.match(/section-([a-z0-9-]+)/i);
        if (!sectionIdMatch) return;
        const sectionId = sectionIdMatch[1],
            contentWidth = featureItems.scrollWidth,
            viewportWidth = window.innerWidth;
        section.classList.contains("pause-on-hover") && (track.addEventListener("mouseenter", () => {
            track.style.animationPlayState = "paused"
        }), track.addEventListener("mouseleave", () => {
            track.style.animationPlayState = "running"
        }))
    }
    adjustFeaturesTrack(section, trackContainer, track, featureItems) {
        if (!section) {
            document.querySelectorAll('[class*="section-"]').forEach(section2 => {
                if (section2.querySelector(".features-track")) {
                    const trackContainer2 = section2.querySelector(".features-track-container"),
                        track2 = section2.querySelector(".features-track"),
                        featureItems2 = track2.querySelector(".feature-items");
                    trackContainer2 && track2 && featureItems2 && this.adjustFeaturesTrack(section2, trackContainer2, track2, featureItems2)
                }
            });
            return
        }
        if (!trackContainer || !track || !featureItems) return;
        const totalWidth = featureItems.offsetWidth * 4;
        totalWidth > 0 && (track.style.width = `${totalWidth}px`), trackContainer.style.height = `${featureItems.offsetHeight}px`
    }
}
document.addEventListener("DOMContentLoaded", function() {
    new ScrollingFeaturesBar
});